

export default {
  namespaced: true,
  state: {
    isMobile: true,
  },
  mutations: {
    setIsMobile: (state, payload) => {
      state.isMobile = payload;
    },
   
  },
  actions: {},
  getters: {},
};
